import { render } from "./BackgroundStars.vue?vue&type=template&id=35391664&scoped=true"
import script from "./BackgroundStars.vue?vue&type=script&lang=js"
export * from "./BackgroundStars.vue?vue&type=script&lang=js"

import "./BackgroundStars.vue?vue&type=style&index=0&id=35391664&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35391664"]])

export default __exports__